<template>
  <div class="layout" style="height:98%;overflow-y:auto">
    <Tree :data="newData" @on-toggle-expand="loadData" @on-select-change="choseTree"></Tree>
  </div>
</template>
<script>
import api from "@/api/aipause";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { globalBus } from "./../../globals/globalBus";
export default {
  props: ["masd"],
  data() {
    return {
      //树结构
      newData: [],
      menuIdList: [],
      listRoleMenu: [],
      // msg: "传递给父组件的值",
      chosedata: [],
      path: this.masd,
      num: 0,
      t: null,
      path: null
    };
  },

  methods: {
    ...mapActions(["handleLogOut"]),

    loadData(item) {
      item.children.splice(0, 1);
      let url = this.getUrl(item.resType);
      let id = item.id;
      api("GET", url, {}, id).then(res => {
        let data = res.data;
        if (data.code === 0) {
          let itemTitle = this.getTitle(item.resType, data);
          item.children = [];
          for (let i = 0; i < itemTitle.length; i++) {
            let itenName = this.getName(item.resType, itemTitle[i]);
            item.children.push({
              title: itenName,
              id: itemTitle[i].id,
              resType: itemTitle[i].resType,
              expand: false,
              children: itemTitle[i].hasSubItems == true ? [{}] : [],
              clientId: itemTitle[i].clientId
            });
          }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    getUrl(objType) {
      if (0 == objType) {
        return "clientSubList";
      } else if (11 == objType) {
        return "stationSubList";
      } else if (12 == objType) {
        return "nodeSubList";
      } else if (13 == objType) {
        return "channelSubList";
      }
    },
    getTitle(objType, obj) {
      if (0 == objType) {
        return obj.station;
      } else if (11 == objType) {
        return obj.node;
      } else if (12 == objType) {
        return obj.channel;
      } else if (13 == objType) {
        return obj.chanName;
      }
    },
    getName(objType, obj) {
      if (0 == objType) {
        return obj.staName;
      } else if (11 == objType) {
        return obj.nodeName;
      } else if (12 == objType) {
        return obj.chanName;
      } else if (13 == objType) {
        return obj.senName;
      }
    },
    choseTree(selectedList) {
      if (selectedList.length == "0") {
        return;
      }
      this.$emit("getData", selectedList);
      this.$emit("getNodeData", selectedList);
      if (selectedList[0]) {
        this.$emit("chosecha", {
          title: selectedList[0]
        });
      }
      if (
        selectedList[0].resType == 11 &&
        this.$route.name !== "connect_cha" &&
        this.$route.name !== "device_instruction" &&
        this.$route.name !== "point_attr"
      ) {
        this.$router.push({
          path: `/device_management/station_properties/${selectedList[0].id}`
        });
      }
      if (
        selectedList[0].resType == 12 &&
        this.$route.name !== "connect_cha" &&
        this.$route.name !== "device_instruction" &&
        this.$route.name !== "point_attr"
      ) {
        this.$router.push({
          path: `/device_management/node_properties/${selectedList[0].id}`
        });
      }
      if (
        selectedList[0].resType == 13 &&
        this.$route.name !== "connect_cha" &&
        this.$route.name !== "device_instruction" &&
        this.$route.name !== "point_attr"
      ) {
        this.$router.push({
          path: `/device_management/channel_data/${selectedList[0].id}`
        });
      }
      if (
        selectedList[0].resType == 14 &&
        this.$route.name !== "connect_cha" &&
        this.$route.name !== "device_instruction" &&
        this.$route.name !== "point_attr"
      ) {
        this.$router.push({
          path: `/device_management/sensor_property/${selectedList[0].id}`
        });
      }
    },

    getDingwei(item) {
      for (let i = 0; i < this.newData.length; i++) {
        this.newData[i].children = [{}];
        this.newData[i].expand = false;
        if (item[0] == this.newData[i].id) {
          this.newData[i].children = [];
          api("GEt", "clientLocate", {}, item[1] + "/" + item[2]).then(res => {
            let data = res.data;
            if (data.code === 0) {
              this.newData[i].expand = true;
              data.tree.selectedNode.children.map((item1)=>{
                  this.newData[i].children.push({
                    title: item1.nodeValue.staName,
                    id: item1.nodeValue.id,
                    resType: item1.nodeValue.resType,
                    selected: item1.nodeValue.id == item[2] ? true :false,
                    expand: false,
                    children: item1.nodeValue.hasSubItems == true ? [{}] : []
                  });
              })
              if(item[1] == 12){
                for(let a = 0 ; a < this.newData[i].children.length ; a++){
                  if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.stationId == this.newData[i].children[a].id){
                    this.newData[i].children[a].expand = true;
                    this.newData[i].children[a].selected = false;
                    this.newData[i].children[a].children = []
                    data.tree.selectedNode.selectedNode.children.map((item1)=>{
                      this.newData[i].children[a].children.push({
                        title: item1.nodeValue.nodeName,
                        id: item1.nodeValue.id,
                        resType: item1.nodeValue.resType,
                        selected: item1.nodeValue.id == item[2] ? true :false,
                        expand: false,
                        children: item1.nodeValue.hasSubItems == true ? [{}] : []
                      });
                    })
                  }
                }
              }
              if(item[1] == 13){
                for(let a = 0 ; a < this.newData[i].children.length ; a++){
                  if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.stationId == this.newData[i].children[a].id){
                    this.newData[i].children[a].expand = true;
                    this.newData[i].children[a].selected = false;
                    this.newData[i].children[a].children = []
                    data.tree.selectedNode.selectedNode.children.map((item1)=>{
                      this.newData[i].children[a].children.push({
                        title: item1.nodeValue.nodeName,
                        id: item1.nodeValue.id,
                        resType: item1.nodeValue.resType,
                        selected: item1.nodeValue.id == item[2] ? true :false,
                        expand: false,
                        children: item1.nodeValue.hasSubItems == true ? [{}] : []
                      });
                    })
                    for(let w = 0 ; w < this.newData[i].children[a].children.length ; w++){
                      if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.nodeId == this.newData[i].children[a].children[w].id){
                        this.newData[i].children[a].children[w].expand = true;
                        this.newData[i].children[a].children[w].selected = false;
                        this.newData[i].children[a].children[w].children = []
                        data.tree.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                          this.newData[i].children[a].children[w].children.push({
                            title: item1.nodeValue.chanName,
                            id: item1.nodeValue.id,
                            resType: item1.nodeValue.resType,
                            selected: item1.nodeValue.id == item[2] ? true :false,
                            expand: false,
                            children: item1.nodeValue.hasSubItems == true ? [{}] : []
                          });
                        })
                      }
                    }
                  }
                }
              }
              if(item[1] == 14){
                for(let a = 0 ; a < this.newData[i].children.length ; a++){
                  if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.stationId == this.newData[i].children[a].id){
                    this.newData[i].children[a].expand = true;
                    this.newData[i].children[a].selected = false;
                    this.newData[i].children[a].children = []
                    data.tree.selectedNode.selectedNode.children.map((item1)=>{
                      this.newData[i].children[a].children.push({
                        title: item1.nodeValue.nodeName,
                        id: item1.nodeValue.id,
                        resType: item1.nodeValue.resType,
                        selected: item1.nodeValue.id == item[2] ? true :false,
                        expand: false,
                        children: item1.nodeValue.hasSubItems == true ? [{}] : []
                      });
                    })
                    for(let w = 0 ; w < this.newData[i].children[a].children.length ; w++){
                      if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.nodeId == this.newData[i].children[a].children[w].id){
                        this.newData[i].children[a].children[w].expand = true;
                        this.newData[i].children[a].children[w].selected = false;
                        this.newData[i].children[a].children[w].children = []
                        data.tree.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                          this.newData[i].children[a].children[w].children.push({
                            title: item1.nodeValue.chanName,
                            id: item1.nodeValue.id,
                            resType: item1.nodeValue.resType,
                            selected: item1.nodeValue.id == item[2] ? true :false,
                            expand: false,
                            children: item1.nodeValue.hasSubItems == true ? [{}] : []
                          });
                        })
                        for(let e = 0 ; e < this.newData[i].children[a].children[w].children.length ; e++){
                          if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.chanId == this.newData[i].children[a].children[w].children[e].id){
                            this.newData[i].children[a].children[w].children[e].expand = true;
                            this.newData[i].children[a].children[w].children[e].selected = false;
                            this.newData[i].children[a].children[w].children[e].children = []
                            data.tree.selectedNode.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                              this.newData[i].children[a].children[w].children[e].children.push({
                                title: item1.nodeValue.senName,
                                id: item1.nodeValue.id,
                                resType: item1.nodeValue.resType,
                                selected: item1.nodeValue.id == item[2] ? true :false,
                              });
                            })
                          }
                        }
                      }
                    }
                  }
                }
                
              }
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      }
    },

    position(){
    },

    //树形控件数据
    getMenu() {
      api("GET", "clientRoot", {}).then(res => {
        let data = res.data;
        if (data.code === 0) {
          for (let i = 0; i < data.clients.length; i++) {
            this.newData.push({
              title: data.clients[i].cliName,
              id: data.clients[i].id,
              resType: 0,
              selected: false,
              expand: false,
              children: data.clients[i].hasStations == true ? [{}] : []
            });
          }
        } else {
          this.handleLogOut().then(() => {
            this.$router.push({
              name: "login"
            });
          });
          this.$Message.error(data.msg);
        }
      });
    },
  },
  mounted() {
    let self = this;
    globalBus.$on("position", function(val) {
      //监听first组件的txt事件
      self.path = val;
    });
    this.getMenu();
  },
  watch: {
    path: {
      handler(newValue, oldValue) {
        this.getDingwei(newValue);
      },
      deep: true
    }
  },
  computed: {}
};
</script>
<style scoped>
/* .tree {
  margin: 20px;
} */
</style>